// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export const pushReaction = (isHighlight: boolean) => {
  // max user id of agora 2^32-1
  const randomId = `${Math.floor(Math.random() * 4294967295)}${Date.now()}`;
  const reaction = document.createElement("span");
  const randomAnimation = ["flowOne", "flowTwo", "flowThree"][
    Math.floor(Math.random() * 3)
  ];
  const randomDuration = (Math.random() * (1.6 - 1.2) + 1.5).toFixed(1);
  reaction.setAttribute(
    "class",
    `reaction-icon ${randomAnimation} ${isHighlight ? "highlight" : ""}`
  );
  reaction.setAttribute("id", randomId);
  reaction.style.animationDuration = `${randomDuration}s`;
  document.getElementById("reactions")?.appendChild(reaction);
  setTimeout(() => {
    document.getElementById(randomId)?.remove();
  }, 4000);
};
